interface CustomImportMetaEnv {
  readonly VITE_ENV: string;
  readonly VITE_SUPABASE_URL: string;
  readonly VITE_SUPABASE_KEY: string;
  readonly VITE_SENTRY_AUTH_TOKEN: string;
  readonly VITE_SENTRY_DSN: string;
  readonly VITE_RELEASE_TAG: string;
  readonly VITE_POSTHOG_TOKEN: string;
  readonly VITE_POSTHOG_API_HOST: string;
}

export function useEnv(): CustomImportMetaEnv;
export function useEnv(key: keyof CustomImportMetaEnv): string | undefined;
export function useEnv(key?: keyof CustomImportMetaEnv): CustomImportMetaEnv | string | undefined {
  if (key) {
    const envKey = import.meta.env[key] as string | undefined;
    return envKey;
  }
  return import.meta.env;
}

export function getEnv(): CustomImportMetaEnv;
export function getEnv(key: keyof CustomImportMetaEnv): string | undefined;
export function getEnv(key?: keyof CustomImportMetaEnv): CustomImportMetaEnv | string | undefined {
  if (key) {
    const envKey = import.meta.env[key] as string | undefined;
    return envKey;
  }
  return import.meta.env;
}
